import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/lib/cart";

export const HeartButton = ({ name, price, testid, className = "" }) => {
  const { add, has, openCart } = useCart();
  const active = has(name);

  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!active) {
      add({ name, price });
      toast.success(`${name} added to your shortlist.`);
    }
    openCart();
  };

  return (
    <button
      data-testid={testid}
      onClick={handle}
      aria-label={active ? `${name} shortlisted` : `Shortlist ${name}`}
      className={`w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-300 shrink-0 ${
        active
          ? "bg-rose-50 border-rose-300"
          : "bg-white/90 border-kiki-line hover:border-rose-300"
      } ${className}`}
    >
      <Heart
        className={`w-4 h-4 transition-colors duration-300 ${active ? "fill-rose-500 text-rose-500" : "text-kiki-muted"}`}
      />
    </button>
  );
};
